import { GET, POST, PUT, DELETE } from '@/server'
import appConfig from '@/config/apiConfig'
const { ApiUrl, OutUrl, syUrl, ossUrl } = appConfig[process.env.VUE_APP_ENV ? process.env.VUE_APP_ENV : 'dev']
const ossImagePath = {
  mainlibdetailFileUrl: 'enterprise/images/' // 主体库上传地址
}

export { GET, POST, PUT, DELETE, ApiUrl, OutUrl, syUrl, ossUrl, ossImagePath }
